import ReactDOM from 'react-dom'

import Router from 'pages/Router'
import 'scss/styles.scss'

ReactDOM.render(<Router />, document.getElementById('root'))
